import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ICalendarState, RawActions, IEventFilter } from '@adage/ace-calendar';

import Dropdown from '../views/dropdown';
import Checkbox from '../components/checkbox';
import { IWACEvent, InputOption, ICalendarReduxState } from '../classes';
import { clearFilterSelections } from "../redux/actions/index";

interface AdaCheckboxExternalProps {
}

interface AdaCheckboxDispatchToProps {
    clearAllFilters: () => any;
}

type AdaCheckboxProps = AdaCheckboxExternalProps & AdaCheckboxDispatchToProps;

const adaCheckbox: React.SFC<AdaCheckboxProps> = (props) => {
    return (
        <div className="cal-nav-ada">
            <Checkbox properties={{ text: "Audio Described", value: "" }} filterKey="ad" propertyToCompare="ad">
                <svg className="svg-icon-md">
                    <use xlinkHref="#audio-description" />
                </svg>
                <span>Audio Described</span>
                </Checkbox>

            <Checkbox properties={{ text: "ASL", value: "" }} filterKey="asl" propertyToCompare="asl">
                <svg className="svg-icon-md">
                    <use xlinkHref="#sign-language" />
                </svg>
                <span>ASL</span>
                </Checkbox>

            <Checkbox properties={{ text: "Open Caption", value: "" }} filterKey="oc" propertyToCompare="oc">
                <svg className="svg-icon-md">
                    <use xlinkHref="#open-caption" />
                </svg>
                <span>Open Caption</span>
                </Checkbox>

            <button className="cal-nav-clear" onClick={props.clearAllFilters.bind(this)}>
                Clear Filters
            </button>
        </div>
    )
}

function mapDispatchToProps(dispatch: Dispatch<ICalendarReduxState>, ownProps: AdaCheckboxExternalProps) {
    return {
        clearAllFilters: () => {
            dispatch(clearFilterSelections());
        }
    }
}

export default connect<null, AdaCheckboxDispatchToProps>(null, mapDispatchToProps)(adaCheckbox);


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/views/ada-checkbox.tsx